import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';
import { getUserDetailsState } from '../redux/userDetails/userSlice';

const PrivateRouteHandler = () => {
  const userDetails = useSelector(getUserDetailsState);

  if (userDetails) return <Outlet />;
  return <Navigate to={'/'} replace />;
};

export default PrivateRouteHandler;
